import { render, staticRenderFns } from "./AcceptInvite.vue?vue&type=template&id=efd5bfe4&scoped=true"
import script from "./AcceptInvite.vue?vue&type=script&lang=js"
export * from "./AcceptInvite.vue?vue&type=script&lang=js"
import style0 from "./AcceptInvite.vue?vue&type=style&index=0&id=efd5bfe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd5bfe4",
  null
  
)

export default component.exports